var breakpoints = {
  /**
   * `xs` breakpoint: 375px
   */
  xs: 375 + 1,

  /**
   * `s` breakpoint: 600px
   */
  s: 600 + 1,

  /**
   * `m` breakpoint: 768px
   */
  m: 768 + 1,

  /**
   * `l` breakpoint: 1024px
   */
  l: 1024 + 1,

  /**
   * `xl` breakpoint: 1280px
   */
  xl: 1280 + 1,

  /**
   * `xxl` breakpoint: 1440px
   */
  xxl: 1440 + 1
};
export { breakpoints };